import { z } from 'zod';
import { MessageDirectionSchema } from '../conversation/message_envelope';

/**
 * A request the logged-in REQUESTER is closing WITH a human CS operator, as a
 * board card in the "Solicitadas" column (spec 2026-09-12). Source: the
 * requester's own app conversation with `handledBy: 'human'`, still open.
 * The conversation does not know WHO travels — this is a request card, not a
 * traveler card; `tripId` (when the CS already linked a trip) lets the client
 * fold it into that trip's card instead.
 */
export const RequestedRequestViewSchema = z.object({
  conversationId: z.string().min(1),
  title: z.string().nullable(),
  lastMessageAt: z.iso.datetime(),
  /** `outbound` = VOLL spoke last (ball with the requester); `inbound` = requester spoke last. */
  lastMessageDirection: MessageDirectionSchema.nullable(),
  lastMessagePreview: z.string().nullable(),
  tripId: z.string().min(1).nullable(),
});
export type RequestedRequestView = z.infer<typeof RequestedRequestViewSchema>;
